// Minimal markdown-lite renderer for blog content.
// Supports: paragraphs, ## / ### headings, "- " bullet lists, **bold**.
// Renders React elements only — no innerHTML, so no XSS surface.
const renderInline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") ? (
      <strong key={i} className="font-semibold text-ink">
        {part.slice(2, -2)}
      </strong>
    ) : (
      part
    )
  );

export const RichText = ({ text = "", className = "" }) => {
  const blocks = text.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={className} data-testid="rich-text">
      {blocks.map((b, i) => {
        if (b.startsWith("### "))
          return (
            <h4 key={i} className="mt-8 mb-2 font-display text-xl font-medium text-forest">
              {renderInline(b.slice(4))}
            </h4>
          );
        if (b.startsWith("## "))
          return (
            <h3 key={i} className="mt-10 mb-3 font-display text-2xl sm:text-3xl font-medium text-forest">
              {renderInline(b.slice(3))}
            </h3>
          );
        if (b.startsWith("- "))
          return (
            <ul key={i} className="my-5 space-y-2.5">
              {b
                .split("\n")
                .filter((l) => l.trim().startsWith("- "))
                .map((l, j) => (
                  <li key={j} className="flex gap-3 leading-relaxed text-[#3A3C3A]">
                    <span className="mt-2.5 h-1.5 w-1.5 shrink-0 bg-gold" />
                    <span>{renderInline(l.trim().slice(2))}</span>
                  </li>
                ))}
            </ul>
          );
        return (
          <p key={i} className="my-5 leading-[1.85] text-[#3A3C3A]">
            {renderInline(b)}
          </p>
        );
      })}
    </div>
  );
};
